import script from "./curriculumForm.vue?vue&type=script&setup=true&lang=js"
export * from "./curriculumForm.vue?vue&type=script&setup=true&lang=js"

import "./curriculumForm.vue?vue&type=style&index=0&id=19e7a28a&lang=scss"

const __exports__ = script;

export default __exports__